import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SfoUiJSONSchema7 } from '../../../../metadata.model';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { MatFormField, MatLabel, MatHint, MatSuffix } from '@angular/material/select';

import { MatInput } from '@angular/material/input';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from '@angular/material/datepicker';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'sfo-date-input',
  templateUrl: './date-input.component.html',
  // Bounded content — cap the width so dates don't span the full form.
  styles: ['mat-form-field { max-width: 14rem; }'],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    FormsModule,
    ReactiveFormsModule,
    MatHint,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
  ],
})
export class DateInputComponent implements OnInit {
  @Input() schema!: SfoUiJSONSchema7;
  @Input() aFormControl!: FormControl;
  isTouchDevice: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.breakpointObserver.observe(['(pointer: coarse)']).subscribe((state: BreakpointState) => {
      this.isTouchDevice = state.matches;
    });

    this.aFormControl.valueChanges.subscribe((value) => {
      // The active datepicker adapter writes either a Moment (moment adapter, e.g.
      // Storybook) OR a native Date (NativeDateAdapter — the publish module imports
      // MatNativeDateModule) into the control. Normalise EITHER to an ISO 'YYYY-MM-DD'
      // string and re-emit (default emitEvent:true) so the value reaching the form model /
      // save path is the string the schema expects — not a Moment/Date object, which the
      // save path can't persist. The guard is self-terminating: the resulting string is
      // neither a Moment nor a Date, so the re-emission pass is ignored (no loop).
      if (value && (moment.isMoment(value) || value instanceof Date)) {
        this.aFormControl.setValue(moment(value).format('YYYY-MM-DD'));
      }
    });
  }
}
